import { Box, Checkbox as MuiCheckbox, FormControlLabel } from "@mui/material";
import { Check } from "@mui/icons-material";
import { ReactNode } from "react";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: ReactNode;
  density?: "comfortable" | "compact";
  disabled?: boolean;
}

// TODO: AUN NO ESTA AFINANDO CORRECTAMENTE EL CHECKBOX, REVISAR DESPUES
const CheckboxBox = ({ size, checked }: { size: number; checked: boolean }) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: "6px",
      border: "1.5px solid",
      borderColor: checked ? "#000" : "tokens.borderStrong",
      bgcolor: checked ? "#000" : "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all .12s ease",
    }}
  >
    {checked && <Check sx={{ fontSize: size * 0.65, color: "#fff" }} />}
  </Box>
);

export const Checkbox = ({ checked, onChange, label, density = "comfortable", disabled }: Props) => {
  const size = density === "compact" ? 16 : 20;

  return (
    <FormControlLabel
      sx={{ alignItems: "flex-start", ml: 0, gap: density === "compact" ? 0.5 : 1 }}
      disabled={disabled}
      control={
        <MuiCheckbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disableRipple
          icon={<CheckboxBox size={size} checked={false} />}
          checkedIcon={<CheckboxBox size={size} checked={true} />}
          sx={{ p: 0, "&:hover": { bgcolor: "transparent" } }}
        />
      }
      label={label}
    />
  );
};
